function importAll(r) {
  r.keys().forEach(r)
}

// Imports all ViewComponent JS files
importAll(require.context("../components", true, /[_\/]component\.js$/))
